import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { TaxOfficeQuickListQuery, TaxOfficeQuickListQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(TaxOfficeQuickListQuery)
@Wrapper(TaxOfficeQuickListQueryHandlerBase)
export class TaxOfficeQuickListQueryHandler {
    public constructor(
        http: Http
    ) { }
}
